const LOCALEMAP = {
    us: {
        Home: 'Home',
        Blog: 'Blog',
    },
    de: {
        Home: 'Titelseite',
        Blog: 'Blog-Center',
    },
    fr: {
        Home: 'première page',
        Blog: 'Centre de blogs',
    },
    it: {
        Home: 'prima pagina',
        Blog: 'Centro Blog',
    },
    es: {
        Home: 'página delantera',
        Blog: 'Centro de blogs',
    },
    jp: {
        Home: 'フロントページ',
        Blog: 'ブログセンター',
    },
    kr: {
        Home: '첫 페이지',
        Blog: '블로그 센터',
    },
    ar: {
        Home: 'الصفحة الأولى',
        Blog: 'مركز المدونة',
    },
    br: {
        Home: 'primeira página',
        Blog: 'Central de Blogs',
    },
};

export { LOCALEMAP };
